export default "__VITE_ASSET__Btu_noBr__"